<template>
    <BigButton
        v-if="sessionStore.activeProjectId"
        task="proceedConfiguration"
        :internal-href="
            configurator({
                configurableProduct: productStore.configurableProduct.url_key,
                mediaclipProjectId: sessionStore.activeProjectId,
            })
        "
    />
</template>

<script setup lang="ts">
import BigButton from '@/components/buttons/BigButton.vue';
import { useProductStore } from '@/stores/products/ProductStore';
import { useMediaclipSessionStore } from '@/stores/tool/MediaclipSessionStore';
import { configurator } from '@/types/wayfinder/routes/tools/mediaclip';

const productStore = useProductStore();
const sessionStore = useMediaclipSessionStore();
</script>
